import type { Player } from "../game";
import type { Position } from "./extractionPlanner";

export function passageExitOffset(
  from: Position,
  to: Position,
  viewFrom: Player,
  step: Readonly<{ x: number; y: number }>,
): { x: number; y: number } {
  const projection = viewFrom === "black" ? 1 : -1;
  const rowDirection = Math.sign(to.row - from.row);
  const columnDirection = Math.sign(to.column - from.column);
  const stepsToExit = rowDirection < 0 ? from.row + 1.7 : 5 - from.row + 0.7;
  return {
    x: columnDirection * projection * step.x * stepsToExit,
    y: rowDirection * projection * step.y * stepsToExit,
  };
}
